// extracted by mini-css-extract-plugin
module.exports = {"loading":"src-components-Loading-index-module__loading--jO1NF","background":"src-components-Loading-index-module__background--Gj78M"};